const LOCAL = 'http://10.253.211.20:8082/api/v1'

const ONLINE = 'http://121.36.15.129:8082/api/v1'


// export const REQUEST_URL = {
//     LOCAL: 'http://192.168.201.53:8082/api/v1',
//     ONLINE: 'http://47.113.178.74/api/v1'
// }

// export const REQUEST_URL = 'http://47.113.178.74/api/v1'

// export const REQUEST_URL = ONLINE
export const REQUEST_URL = ONLINE